export default __webpack_public_path__ + "static/media/graySmall.d2214958.svg";